import { render, staticRenderFns } from "./FlightsLoading.vue?vue&type=template&id=058fa868"
import script from "./FlightsLoading.vue?vue&type=script&lang=js"
export * from "./FlightsLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppLoading: require('/home/forge/farescraper.com/components/AppLoading.vue').default})
